export const GET_LISTING_DETAILS_SUCCESS = 'GET_LISTING_DETAILS_SUCCESS';
export const SET_LISTING_DETAILS_LOADING = 'SET_LISTING_DETAILS_LOADING';
